import React from 'react';

const Minnesota = () => {
  return (
    <div>
      
    </div>
  );
}

export default Minnesota;
